import { formatNumber } from "../lib/format";

export function TrendChart({ points, label }: { points: { x: string; y: number }[]; label: string }) {
  if (points.length < 2) {
    return <p className="muted">至少录入两个日期后，才会画出{label}趋势。</p>;
  }
  const width = 640;
  const height = 72;
  const padX = 28;
  const padTop = 22;
  const padBottom = 12;
  const max = Math.max(...points.map((point) => point.y), 0);
  const span = max || 1;
  const coords = points.map((point, index) => {
    const x = padX + (index * (width - padX * 2)) / (points.length - 1);
    const y = height - padBottom - (point.y / span) * (height - padTop - padBottom);
    return { x, y, value: point.y };
  });
  const first = points[0];
  const last = points[points.length - 1];
  const baseline = height - padBottom;
  return (
    <figure className="chart-wrap">
      <svg viewBox={`0 0 ${width} ${height}`} className="chart" role="img" aria-label={`${label}趋势`}>
        <line x1={padX} y1={baseline} x2={width - padX} y2={baseline} stroke="#eee8ea" strokeWidth="1" />
        <polyline fill="none" stroke="currentColor" strokeWidth="2" points={coords.map((point) => `${point.x},${point.y}`).join(" ")} />
        {coords.map((point, index) => (
          <g key={`${point.x}-${point.value}`}>
            <circle cx={point.x} cy={point.y} r="4" fill="#fff" stroke="currentColor" />
            <text
              x={point.x}
              y={Math.max(14, point.y - 10)}
              textAnchor={index === 0 ? "start" : index === coords.length - 1 ? "end" : "middle"}
              fill="#6f686b"
              fontSize="12"
            >
              {formatNumber(point.value)}
            </text>
          </g>
        ))}
      </svg>
      <figcaption>
        {label} {formatNumber(first?.y)} → {formatNumber(last?.y)} · {first?.x} → {last?.x}
      </figcaption>
    </figure>
  );
}
